import type { CoreApiClient } from "../client";
import { createGatewayMutations } from "../mutations/gateway.mutations";
import { createGatewayQueries } from "../queries/gateway.queries";

export const createGatewayRepository = (api: CoreApiClient) => ({
  ...createGatewayQueries(api),
  ...createGatewayMutations(api),
});
